import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonLink } from 'components/shared/ButtonLink';
import { Heading1, Heading2 } from 'components/shared/Typography';
import { LoggedUserContext } from 'context/logged-user/loggeduser.context';
import { useI18n } from 'hooks/useI18n';
import { Trans } from 'next-i18next';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import {
  StyledContainer,
  StyledHeadingCarousel,
  StyledHeadingCarouselInner,
  StyledHero,
  StyledImage,
  StyledIntro
} from './ApplicationsHero.styled';

const Words: React.FC = () => {
  const { t } = useI18n('applications-landing');

  return (
    <StyledHeadingCarousel>
      <StyledHeadingCarouselInner>
        <span className="start">{t('applicationsLanding.hero.word1')}</span>
        <span aria-hidden="true">{t('applicationsLanding.hero.word2')}</span>
        <span aria-hidden="true">{t('applicationsLanding.hero.word3')}</span>
        <span aria-hidden="true">{t('applicationsLanding.hero.word4')}</span>
        <span aria-hidden="true">{t('applicationsLanding.hero.word5')}</span>
        <span aria-hidden="true">{t('applicationsLanding.hero.word1')}</span>
      </StyledHeadingCarouselInner>
    </StyledHeadingCarousel>
  );
};

const ApplicationsHero: React.FC = () => {
  const { t } = useI18n('applications-landing');
  const { locale } = useRouter();
  const { user } = useContext(LoggedUserContext);

  let ctaUrl = `${getAppUrl(
    APP_URLS.join,
    locale
  )}?returnUrl=/${locale}${getAppUrl(
    APP_URLS.portalV2ThirdPartyApplications,
    locale
  )}&source=your_apps_application`;

  if (user) {
    ctaUrl = `${getAppUrl(APP_URLS.portalV2ThirdPartyApplications, locale)}`;
  }

  return (
    <StyledHero>
      <StyledImage>
        <StyledContainer>
          <Heading1>
            <Trans
              i18nKey={'applicationsLanding.hero.title'}
              ns="applications-landing"
              components={{
                words: <Words />
              }}
            ></Trans>
          </Heading1>
        </StyledContainer>
      </StyledImage>
      <StyledIntro>
        <StyledContainer>
          <div>
            <Heading2
              editorial
              dangerouslySetInnerHTML={{
                __html: t('applicationsLanding.hero.intro.title')
              }}
            />
            <div
              dangerouslySetInnerHTML={{
                __html: t('applicationsLanding.hero.intro.desc')
              }}
            ></div>
            <Link href={ctaUrl} passHref>
              <ButtonLink variant="primary" sizes="md">
                <FontAwesomeIcon icon={faCheckCircle} />
                <span>{t('applicationsLanding.hero.intro.cta')}</span>
              </ButtonLink>
            </Link>
          </div>
          <img
            src={getPublicPath(
              `/images/applicationsLanding/${locale}/analytics.png`
            )}
            alt=""
          />
        </StyledContainer>
      </StyledIntro>
    </StyledHero>
  );
};

export default ApplicationsHero;
